import { GetterTree } from "vuex";
import { MapSetupGroup, MapSetupItem, MapSetupLayer, MapSetupLayerItemRequest, MapSetupState } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<MapSetupState, RootState> = {
    getGroupsWithLayers: state => state.GroupsWithLayers,
    getSelectedLayerId: state => state.SelectedMapLayerId,
    getLayerItemById: state => (mapSetupItemRequest: MapSetupLayerItemRequest): MapSetupItem => {
        let itemFound = undefined;
        mapSetupItemRequest.mapSetupLayers.forEach(layer => {

            if (!itemFound) {
                let groupIndex = state.GroupsWithLayers.findIndex((x: MapSetupGroup) => x.groupId == layer.groupId);

                let groupLayers = state.GroupsWithLayers[groupIndex].mapLayers;

                let layerIndex = groupLayers.findIndex((x: MapSetupLayer) => x.mapLayerId == layer.mapLayerId);
                let itemIndex = groupLayers[layerIndex].layerItems.findIndex((x: MapSetupItem) =>
                    x.mapLayerItemID == mapSetupItemRequest.mapSetupLayerItem.mapLayerItemID
                );

                if (itemIndex !== -1) {
                    itemFound = groupLayers[layerIndex].layerItems[itemIndex];
                }
            }
        });

        return itemFound;
    }
};
